import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  class: "grid-box grid-col scroll-y",
  id: "leads-details"
}
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = { class: "top-section grid-box grid-row grid-col" }
const _hoisted_4 = { class: "text-input input-el col-1 row-1" }
const _hoisted_5 = { class: "text-input input-el col-1 row-2" }
const _hoisted_6 = {
  key: 0,
  class: "err"
}
const _hoisted_7 = { class: "grid-row grid-row row-auto phone-postal col-1 row-3" }
const _hoisted_8 = { class: "text-input input-el" }
const _hoisted_9 = { class: "text-input input-el" }
const _hoisted_10 = { class: "grid-row row-auto col-2 row-1" }
const _hoisted_11 = { class: "input-el select-el" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "input-el select-el col-2 row-2" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "input-el select-el col-2 row-3" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "grid-row buttons row-4" }
const _hoisted_18 = { class: "buttons" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "buttons" }
const _hoisted_21 = { class: "grid-row fill-space" }
const _hoisted_22 = { class: "text-input input-el text-area-el fill-space" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[11] || (_cache[11] = [
          _createElementVNode("div", { class: "loading-circle" }, null, -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("form", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "Full Name", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "input-box text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedItem.name.fullName) = $event)),
          placeholder: "Jean C. Lupus",
          type: "text"
        }, null, 512), [
          [_vModelText, $setup.selectedItem.name.fullName]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "Email", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "input-box text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedItem.email) = $event)),
          placeholder: "email@example.com",
          type: "email"
        }, null, 512), [
          [_vModelText, $setup.selectedItem.email]
        ]),
        ($props.errorMessages?.email && $props.errorMessages.email.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($props.errorMessages.email), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "Phone Number", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input-box text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedItem.phone) = $event)),
            placeholder: "555-555-5555",
            type: "tel",
            pattern: "[0-9]{3}-[0-9]{3}-[0-9]{4}"
          }, null, 512), [
            [_vModelText, $setup.selectedItem.phone]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "Postal Code", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input-box text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedItem.postalCode) = $event)),
            placeholder: "00000",
            type: "text",
            pattern: "[0-9]{5}-[0-9]{4}?"
          }, null, 512), [
            [_vModelText, $setup.selectedItem.postalCode]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          class: "text-input input-el",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.checkDate()))
        }, [
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "Last Contacted", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input-box text date-selector",
            id: "datepicker",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedItem.lastContact) = $event)),
            placeholder: "mm/dd/yyyy",
            type: "date",
            max: "currentDay"
          }, null, 512), [
            [_vModelText, $setup.selectedItem.lastContact]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "Status", -1)),
          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "chevron" }, [
            _createElementVNode("svg", {
              class: "icon chevron-down chevron",
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                class: "path filled",
                d: "M5.41 6L10 10.58L14.59 6L16 7.41L10 13.41L4 7.41L5.41 6Z"
              })
            ])
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.selectedItem.status) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activityStatusOptions, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option,
                value: option
              }, _toDisplayString(option), 9, _hoisted_12))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.selectedItem.status]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "Interested In", -1)),
        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "chevron" }, [
          _createElementVNode("svg", {
            class: "icon chevron-down chevron",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              class: "path filled",
              d: "M5.41 6L10 10.58L14.59 6L16 7.41L10 13.41L4 7.41L5.41 6Z"
            })
          ])
        ], -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.selectedItem.productInterest) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.interestOptions, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option,
              value: option
            }, _toDisplayString(option), 9, _hoisted_14))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.selectedItem.productInterest]
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "Origin", -1)),
        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "chevron" }, [
          _createElementVNode("svg", {
            class: "icon chevron-down chevron",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              class: "path filled",
              d: "M5.41 6L10 10.58L14.59 6L16 7.41L10 13.41L4 7.41L5.41 6Z"
            })
          ])
        ], -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.selectedItem.leadOrigin) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.originOptions, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option,
              value: option
            }, _toDisplayString(option), 9, _hoisted_16))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.selectedItem.leadOrigin]
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("span", _hoisted_18, [
          _cache[23] || (_cache[23] = _createElementVNode("p", null, "Create Customer Account for Lead", -1)),
          _createElementVNode("button", {
            class: "secondary outline createCust",
            disabled: !$props.checkStatus,
            onClick: $setup.createCustAccount
          }, "Create", 8, _hoisted_19)
        ]),
        _createElementVNode("span", _hoisted_20, [
          _cache[24] || (_cache[24] = _createElementVNode("p", null, "Send Email to Lead", -1)),
          _createElementVNode("button", {
            class: "secondary outline createCust",
            onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.generateEmail($props.email, $props.interest)))
          }, "Email")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "Notes", -1)),
        _withDirectives(_createElementVNode("textarea", {
          class: "fill-space",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.selectedItem.notes) = $event))
        }, null, 512), [
          [_vModelText, $setup.selectedItem.notes]
        ])
      ])
    ])
  ]))
}